export function StatCard({ label, value, icon: Icon, accent = "amber", testId, onClick }) {
  const accents = {
    amber: "text-amber-400 bg-amber-500/12 border-amber-500/25",
    cyan: "text-cyan-400 bg-cyan-500/12 border-cyan-500/25",
    green: "text-emerald-400 bg-emerald-500/12 border-emerald-500/25",
    red: "text-red-400 bg-red-500/12 border-red-500/25",
    slate: "text-slate-300 bg-slate-500/12 border-slate-500/25",
  };
  const interactive = typeof onClick === "function";
  return (
    <div
      data-testid={testId}
      onClick={onClick}
      role={interactive ? "button" : undefined}
      tabIndex={interactive ? 0 : undefined}
      onKeyDown={interactive ? (e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onClick(); } } : undefined}
      className={`pgp-card p-5 pgp-fade-up ${interactive ? "cursor-pointer hover:border-slate-500/40 hover:bg-slate-800/30 transition-colors" : ""}`}
    >
      <div className="flex items-center justify-between">
        <span className="text-xs uppercase tracking-wider text-slate-500 font-mono">{label}</span>
        {Icon && (
          <div className={`h-8 w-8 rounded-lg border flex items-center justify-center ${accents[accent]}`}>
            <Icon className="h-4 w-4" />
          </div>
        )}
      </div>
      <div className="mt-3 text-3xl font-head font-extrabold text-slate-50">{value}</div>
    </div>
  );
}
